"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _broadcastSocketManager = require("./broadcastSocketManager");
Object.keys(_broadcastSocketManager).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _broadcastSocketManager[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _broadcastSocketManager[key];
    }
  });
});